import React, { useMemo } from 'react';

import { useStore, useTranslation } from '../../../../../../hooks';
import { SideBarNavigationKey } from '../../../../../../enums';
import { T } from '../../../../../../constants';
import { observer } from 'mobx-react-lite';

import './style.scss';

interface SideBarNavigationProps {
  showLobby: boolean;
  showPascalPromotions: boolean;
  showTopWinners: boolean;
  activeItem: SideBarNavigationKey;
  onSelect: (key: SideBarNavigationKey) => void;
}

export const SideBarNavigation: React.FC<SideBarNavigationProps> = observer(({
  onSelect,
  showLobby,
  activeItem,
  showTopWinners,
  showPascalPromotions
}) => {

  const { sidebarMenuStore } = useStore();
  const { lobbyNotifCount, hasPromotionsNotification, hasTopWinsNotification } = sidebarMenuStore;

  const t = useTranslation();

  const navItems = useMemo(() => {
    const items = [
      {
        labelKey: T.LOBBY,
        visible: showLobby,
        key: SideBarNavigationKey.Lobby,
        iconClass: 'icon-navigation-lobby',
        withNotification: !!lobbyNotifCount
      },
      {
        labelKey: T.PROMOTIONS,
        visible: showPascalPromotions,
        key: SideBarNavigationKey.Promotions,
        iconClass: 'icon-navigation-promotions',
        withNotification: hasPromotionsNotification
      },
      {
        labelKey: T.WINNERS,
        visible: showTopWinners,
        key: SideBarNavigationKey.Winners,
        iconClass: 'icon-navigation-winners',
        withNotification: hasTopWinsNotification
      },
    ];
    return items.filter(item => item.visible);
  }, [showLobby, showPascalPromotions, showTopWinners, lobbyNotifCount, hasPromotionsNotification, hasTopWinsNotification]);

  return (
    <div className="sideBarNavigationHolder">
      <nav className="sideBarNavigation">
        {navItems.map(({ key, labelKey, iconClass, withNotification }) => (
          <button
            key={key}
            type="button"
            className={`sideBarNavigationItem ${activeItem === key ? 'sideBarNavigationItemActive' : ''}`}
            onClick={() => onSelect(key)}
          >
            <span className={`sideBarNavigationIcon ${withNotification ? 'with-notification' : ''}`}>
              <span className={iconClass} />
            </span>
            <span className="sideBarNavigationLabel">{t(labelKey)}</span>
          </button>
        ))}
      </nav>
    </div>
  );
});
